import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { api } from "@/lib/api";

export default function BrandMarquee({ dark = false }) {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    api.get("/brands").then(({ data }) => setBrands((data || []).filter((b) => b.logo)));
  }, []);

  if (!brands.length) return null;

  return (
    <div
      data-testid="brand-marquee"
      className={`py-10 border-y ${dark ? "bg-ink border-white/10" : "bg-stone border-line"}`}
    >
      <Marquee speed={40} gradient={false} autoFill>
        {brands.map((b) => (
          <div key={b.id || b.name} className="flex items-center gap-16 pr-16">
            <div className="bg-white rounded-lg px-8 py-5 flex items-center justify-center h-24 w-52 shadow-sm">
              <img
                src={b.logo}
                alt={b.name}
                title={b.name}
                className="max-h-full max-w-full object-contain"
                loading="lazy"
              />
            </div>
            <span className={`text-sand text-2xl ${dark ? "opacity-70" : ""}`}>✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
